module.exports = __webpack_public_path__ + "img/serve3.b6a5eb52.png";